// ============================================================================
// CENTRAL CONFIGURATION — The Law Office of Ronald K. Nolen, LLC
// ----------------------------------------------------------------------------
// Update firm contact details, reviews, and Valencia's title in ONE place here.
// NOTE: Contact info below is intentionally placeholder text. Do NOT invent
// real phone numbers, emails, or addresses. Replace "To be added" when known.
// Resend keys / Calendly URL live in /app/backend/.env (never in frontend code).
// ============================================================================

export const IMAGES = {
  logo: "https://customer-assets-0z36b82j.emergentagent.net/job_0406435e-2d03-4df0-9514-07c23ec6661f/artifacts/71dd6ioi_nolen-law-logo.png",
  heroRiver: "https://customer-assets-0z36b82j.emergentagent.net/job_0406435e-2d03-4df0-9514-07c23ec6661f/artifacts/j4togrbk_chicago-river-homepage.png",
  ronald: "https://customer-assets-0z36b82j.emergentagent.net/job_0406435e-2d03-4df0-9514-07c23ec6661f/artifacts/bcsd38j5_ronald-nolen-bio-portrait.png",
  valencia: "https://customer-assets-0z36b82j.emergentagent.net/job_0406435e-2d03-4df0-9514-07c23ec6661f/artifacts/uxfegn2h_valencia-king-headshot.png",
  buckingham: "https://customer-assets-0z36b82j.emergentagent.net/job_0406435e-2d03-4df0-9514-07c23ec6661f/artifacts/dinlth81_buckingham-fountain-reviews.png",
};

export const SITE = {
  firmName: "The Law Office of Ronald K. Nolen, LLC",
  shortName: "Nolen Law",
  location: "Chicago, Illinois",

  // ----- Contact information (VERIFIED — Dec 2025) -----
  phone: "312-394-0184",
  phoneRaw: "3123940184",
  publicEmail: "rknolenesq@rknolenlaw.com",
  address: "9723 S Western Ave, Chicago, IL 60643",
  addressLines: ["9723 S Western Ave", "Chicago, IL 60643", "By Appointment Only"],
  officeHours: "Monday–Friday, 9:00 AM – 4:00 PM (By Appointment Only, Closed on Holidays)",
  officeHoursLines: ["Monday–Friday", "9:00 AM–4:00 PM", "By Appointment Only", "Closed on Holidays"],

  // ----- Admin note: these are configured in /app/backend/.env -----
  // RESEND_API_KEY, INQUIRY_RECIPIENT_EMAIL, RESEND_FROM_EMAIL, CALENDLY_URL

  // ----- Valencia King title -----
  valenciaTitle: "Trademark Attorney",

  // ----- Social links: hidden until real URLs are entered -----
  socialLinks: {
    linkedin: "",
    instagram: "",
    facebook: "",
    twitter: "",
  },

  disclaimer:
    "The information provided on this website is for general informational purposes only and does not constitute legal advice. Viewing this website or submitting an inquiry does not create an attorney-client relationship.",
};

// Helper: only social links that have a real URL configured.
export const activeSocials = () =>
  Object.entries(SITE.socialLinks).filter(([, url]) => url && url.trim().length > 0);
